import React from 'react';
import { useState } from 'react';

import AddImage from 'components/upload-image/AddImage';
import ImageEditor from './ImageEditor';

export default function Main() {
  const [image, setImage] = useState('');
  const [vidStream, setVidStream] = useState(null);
  const [fileName, setFileName] = useState('');

  return (
    <div>
      <div className="flex justify-center items-center gap-2 my-8">
        <img
          src={`${process.env.PUBLIC_URL}/images/pawlogo.png`}
          alt="paw logo"
          className="w-[24px] h-[24px]"
        />
        <h2 className="text-xl lg:text-2xl font-bold">
          Rescue Me! Image Editor
        </h2>
      </div>

      {!image.length ? (
        <AddImage
          setImage={setImage}
          vidStream={vidStream}
          setVidStream={setVidStream}
          setFileName={setFileName}
        />
      ) : (
        <ImageEditor
          image={image}
          setVidStream={setVidStream}
          setImage={setImage}
          fileName={fileName}
        />
      )}
    </div>
  );
}
